/**
 * window.DATA_LAYER
 * observer на dataLayer отслеживающий пуши
 */
const dataLayerListener = `<script>
   window.DATA_LAYER = (function(){
      var listeners = [];
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push = function (value) {
         for(var i = 0; i < listeners.length; i++) listeners[i](value);
         return Array.prototype.push.apply(window.dataLayer, arguments);
      }
      return {
         subscribe: function(notifyCallback){listeners.push(notifyCallback);},
      };
   })();
</script>`;

module.exports = {
    dataLayerListener
};
